import Vue from 'vue'
import Router from 'vue-router'

import axios from 'axios'
import VueAxios from 'vue-axios'

// Containers
import HomeLayout from '@/containers/HomeLayout'

// View
import Home from '@/views/admin/Home'

// Banner
import BannerForm from '@/views/admin/banner/BaseForm'
import BannerList from '@/views/admin/banner/List'

// Single
import MenuList from '@/views/admin/menu/List'
import BaseForm from '@/views/admin/menu/BaseForm'
import AvailableForm from '@/views/admin/menu/AvailableForm'
import ToppingForm from '@/views/admin/menu/ToppingForm'
import OptionForm from '@/views/admin/menu/OptionForm'
import MenuSequence from '@/views/admin/menu/Sequence'

// Group
import MenuGroupList from '@/views/admin/menu-group/List'
import MenuGroupBaseForm from '@/views/admin/menu-group/BaseForm'
import MenuGroupSettingBaseForm from '@/views/admin/menu-group/BaseSettingForm'

// Combo
import ComboList from '@/views/admin/combo/List'
import ComboBaseForm from '@/views/admin/combo/BaseForm'
import ComboGroupBaseForm from '@/views/admin/combo/GroupBaseForm'
import ComboGroupForm from '@/views/admin/combo/GroupForm'
import ComboAvailableForm from '@/views/admin/combo/AvailableForm'

// FirstLayer
import FirstLayerList from '@/views/admin/first-layer/List'
import FirstLayerBaseForm from '@/views/admin/first-layer/BaseForm'

// SecondLayer
import SecondLayerList from '@/views/admin/second-layer/List'
import SecondLayerBaseForm from '@/views/admin/second-layer/BaseForm'

// Topping
import ToppingList from '@/views/admin/topping/List'
import ToppingBaseForm from '@/views/admin/topping/BaseForm'

// Outlet
import OutletsList from '@/views/admin/outlets/List'
import OutletsForm from '@/views/admin/outlets/OutletsForm'
import OutletsMenuControl from '@/views/admin/outlets/MenuControlForm'
import OutletsTableControl from '@/views/admin/outlets/TableList'
import TableForm from '@/views/admin/outlets/TableForm'
import OutletOutOfStock from '@/views/admin/outlets/OutletOutOfStock'
import OutletMenuOutOfStock from '@/views/admin/outlets/OutletMenuOutOfStock'
import OutletToppingOutOfStock from '@/views/admin/outlets/OutletToppingOutOfStock'
import OutletMenuExclusionForm from '@/views/admin/outlets/MenuExclusionForm'
import OutletToppingExclusionForm from '@/views/admin/outlets/ToppingExclusionForm'
import AvailableDealsList from '@/views/admin/outlets/AvailableDealsList'

// Tradezone
import TradezoneList from '@/views/admin/tradezone/ListTradezone'
import SubTradezoneList from '@/views/admin/tradezone/ListSubTradezone'
import FormSubTradezone from '@/views/admin/tradezone/FormSubTradezone'

// Order
import OrderList from '@/views/admin/order/List'
import ListErrors from '@/views/admin/order/ListErrors'
import OrderDetail from '@/views/admin/order/BaseForm'
import Component from '@/views/Component'

// Profile
import Profile from '@/views/admin/user/Profile'

// Client
import ClientList from '@/views/admin/client/List'
import ClientForm from '@/views/admin/client/Form'
import Content from '@/views/admin/client/Content'

// Client
import CampaignList from '@/views/admin/campaign/List'
import CampaignForm from '@/views/admin/campaign/Form'

// Blacklist
import BlacklistList from '@/views/admin/blacklist/List'
import BlacklistForm from '@/views/admin/blacklist/Form'

import TopicList from '@/views/admin/topic/List'
import TopicForm from '@/views/admin/topic/Form'

// Customers
import CustomersList from '@/views/admin/customer/List'
import CustomerDetail from '@/views/admin/customer/Detail'
// User
import UsersList from '@/views/admin/user/List'
import UsersForm from '@/views/admin/user/BaseForm'

// Role
import RoleList from '@/views/admin/roles/List'
import RoleForm from '@/views/admin/roles/BaseForm'

// Permission
import PermissionList from '@/views/admin/permissions/List'
import PermissionForm from '@/views/admin/permissions/BaseForm'

// ErrorMessage
import ErrorMessageList from '@/views/admin/error-message/List'
import ErrorMessageBaseForm from '@/views/admin/error-message/BaseForm'

// Aws
import AwsForm from '@/views/admin/aws/BaseForm'

// Coupon
import CouponList from '@/views/admin/coupon/List'
import CouponBaseForm from '@/views/admin/coupon/BaseForm'
import CouponBaseFormChild from '@/views/admin/coupon/BaseFormChild'
import CouponExternalList from '@/views/admin/coupon/ExternalList'
import CouponCustomerList from '@/views/admin/coupon/CustomerList'
import CouponGESList from '@/views/admin/coupon/GESList'
import CouponCustomerBaseForm from '@/views/admin/coupon/CustomerBaseForm'
import CouponImportHistory from '@/views/admin/coupon/ImportHistory'

// Game
import GameList from '@/views/admin/game/List'
import GameSettingForm from '@/views/admin/game/SettingForm'
import GamingRule from '@/views/admin/game/GamingRule'
import HistoryList from '@/views/admin/game/HistoryList'

// Views - Pages
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'

import AdminLogin from '@/views/admin/Login'

//check-otp
import CheckOtp from '@/views/admin/CheckOtp'

// Forgot Password
import ForgotPassword from '@/views/admin/ForgotPassword'

// Forgot Password
import ResetPassword from '@/views/admin/ResetPassword'

// Category
import CategoryList from '@/views/admin/category/List'
import CategoryForm from '@/views/admin/category/BaseForm'

// Store Group Management
import StoreGroupList from '@/views/admin/store_group/List'
import StoreGroupForm from '@/views/admin/store_group/BaseForm'

// report
import HitRateReport from '@/views/admin/report/HitRateReport'
import HourlySaleReport from '@/views/admin/report/HourlySaleReport'
import RosterReport from '@/views/admin/report/RosterReport'
import CouponRedemptionReport from '@/views/admin/report/CouponRedemptionReport'
import Hotpods from '@/views/admin/report/Hotpods'
import StoreHealthCheck from '@/views/admin/report/StoreHealthCheck'
import NewSalesReport from '@/views/admin/report/NewSalesReport'
import ContactlessCurbsideTransactions from '@/views/admin/report/ContactlessCurbsideTransactions'

// Menu attribute
import MenuAttributeList from '@/views/admin/menu-attribute/List'
import MenuAttributeForm from '@/views/admin/menu-attribute/BaseForm'

// menu Half Half
import MenuHalfHalfList from '@/views/admin/menu-half-half/List'
import MenuHalfHalfForm from '@/views/admin/menu-half-half/BaseForm'

// Menu out of stock
import MenuOutOfStockList from '@/views/admin/menu-out-of-stock/List'

//Audit
import AuditTrail from '@/views/admin/audit-trail/BaseForm'

// ReasonStatus
import ReasonStatusList from '@/views/admin/reason-status/List'
import ReasonStatusForm from '@/views/admin/reason-status/BaseForm'

// Email template
import EmailTemplateList from '@/views/admin/email-template/List'
import EmailTemplateForm from '@/views/admin/email-template/BaseForm'
import EmailTemplateDiffForm from '@/views/admin/email-template/DiffForm'
import EmailTemplateTriggerForm from '@/views/admin/email-template/TriggerForm'
import EmailTemplateTriggerList from '@/views/admin/email-template/TriggerList'

// Earning framework
import EarningFrameworkList from '@/views/admin/earning-framework/List'

Vue.use(Router)
Vue.use(VueAxios, axios)

export default new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/login',
      name: 'AdminLogin',
      component: AdminLogin,
      meta: {auth: false}
    },
    {
      path: '/check-otp/:uuid',
      name: 'CheckOtp',
      component: CheckOtp,
      meta: {auth: false}
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: {auth: false}
    },
    {
      path: '/setnewpassword/:token',
      props: true,
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {auth: false}
    },
    {
      path: '/',
      redirect: '/home',
      name: 'gms',
      component: HomeLayout,
      meta: {
        // auth: {roles: ['Admin', 'aaaa']},
        auth: true,
        progress: {
          func: [
            {call: 'color', modifier: 'temp', argument: '#ffb000'},
            {call: 'fail', modifier: 'temp', argument: '#6e0000'},
            {call: 'location', modifier: 'temp', argument: 'top'},
            {call: 'transition', modifier: 'temp', argument: {speed: '1.5s', opacity: '0.8s', termination: 400}}
          ]
        },
        label: 'gms'
      },
      children: [
        {
          path: 'home',
          name: 'home',
          component: Home,
          meta: {
            label: 'home'
          }
        },
        {
          path: '/profile',
          name: 'Profile',
          component: Profile,
          meta: {auth: true}
        },
        {
          path: 'component',
          name: 'Component',
          component: Component
        },
        {
          path: 'sequence',
          name: 'sequence',
          component: MenuSequence,
          props: true,
          meta: {
            label: 'sequence'
          }
        },
        {
          path: 'content',
          name: 'content',
          component: Content,
          props: true,
          meta: {
            label: 'content'
          }
        },
        {
          path: 'first-layer',
          name: 'first_layer',
          redirect: '/first-layer',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'first_layer'
          },
          children: [
            {
              path: '',
              name: 'first_layer_list',
              component: FirstLayerList,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':uuid',
              name: 'first_layer_create',
              component: FirstLayerBaseForm,
              meta: {
                label: 'create'
              },
              props: true
            },
            {
              path: 'edit/:uuid',
              name: 'first_layer_edit',
              component: FirstLayerBaseForm,
              props: true,
              meta: {
                label: 'edit'
              }
            },
          ]
        },
        {
          path: 'second-layer',
          name: 'second_layer',
          redirect: '/second-layer',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'second_layer'
          },
          children: [
            {
              path: '',
              name: 'second_layer_list',
              component: SecondLayerList,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':uuid',
              name: 'second_layer_create',
              component: SecondLayerBaseForm,
              meta: {
                label: 'create'
              },
              props: true
            },
            {
              path: 'edit/:uuid',
              name: 'second_layer_edit',
              component: SecondLayerBaseForm,
              props: true,
              meta: {
                label: 'edit'
              }
            },
          ]
        },
        {
          path: 'topping',
          name: 'topping',
          redirect: '/topping',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'topping'
          },
          children: [
            {
              path: '',
              name: 'topping_list',
              component: ToppingList,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':uuid',
              name: 'topping_create',
              component: ToppingBaseForm,
              meta: {
                label: 'create'
              },
              props: true
            },
            {
              path: 'edit/:uuid',
              name: 'topping_edit',
              component: ToppingBaseForm,
              props: true,
              meta: {
                label: 'edit'
              }
            },
          ]
        },
        {
          path: 'menu-group',
          name: 'menu_group',
          redirect: '/menu-group',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'menu_group'
          },
          children: [
            {
              path: '',
              name: 'menu_group_list',
              component: MenuGroupList,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':id',
              name: 'menu_group_create',
              component: MenuGroupBaseForm,
              meta: {
                label: 'create'
              },
              props: true
            },
            {
              path: 'edit/:id',
              name: 'menu_group_edit',
              component: MenuGroupBaseForm,
              props: true,
              meta: {
                label: 'edit'
              }
            },
            {
              path: 'common-setting/:id',
              name: 'menu_group_setting',
              component: MenuGroupSettingBaseForm,
              props: true,
              meta: {
                label: 'common_settings'
              }
            }
          ]
        },
        {
          path: 'banner',
          name: 'banner',
          redirect: '/banner',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'banner'
          },
          children: [
            {
              path: '',
              name: 'banner_list',
              component: BannerList,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':uuid',
              name: 'banner_create',
              component: BannerForm,
              props: true,
              meta: {
                label: 'campaign_create'
              }
            },
            {
              path: 'edit/:uuid',
              name: 'banner_edit',
              component: BannerForm,
              props: true,
              meta: {
                label: 'banner_edit'
              }
            }
          ]
        },
        {
          path: 'menu',
          name: 'menu',
          redirect: '/menu',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'menu'
          },
          children: [
            {
              path: '',
              name: 'menu_list',
              component: MenuList,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':id',
              name: 'menu_create',
              component: BaseForm,
              meta: {
                label: 'create'
              },
              props: true
            },
            {
              path: 'edit/:id',
              name: 'menu_edit',
              component: BaseForm,
              props: true,
              meta: {
                label: 'edit'
              }
            },
            {
              path: 'topping/:id',
              name: 'menu_topping',
              component: ToppingForm,
              props: true,
              meta: {
                label: 'topping'
              }
            },
            {
              path: 'available/:id',
              name: 'menu_available',
              component: AvailableForm,
              props: true,
              meta: {
                label: 'available'
              }
            },
            {
              path: 'option/:id',
              name: 'menu_option',
              component: OptionForm,
              props: true,
              meta: {
                label: 'crust_size'
              }
            }
          ]
        },
        {
          path: 'coupon',
          name: 'coupon',
          redirect: '/coupon',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'coupon'
          },
          children: [
            {
              path: '',
              name: 'coupon_list',
              component: CouponList,
              props: true,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':id',
              name: 'coupon_create',
              component: CouponBaseForm,
              meta: {
                label: 'create'
              },
              props: true
            },
            {
              path: 'edit/:id',
              name: 'coupon_edit',
              component: CouponBaseForm,
              props: true,
              meta: {
                label: 'edit'
              }
            }
          ]
        },
        {
          path: 'child-coupon',
          name: 'child_coupon',
          redirect: '/child-coupon',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'child_coupon'
          },
          children: [
            {
              path: '',
              name: 'coupon_external_list',
              component: CouponExternalList,
              props: true,
              meta: {
                label: 'list'
              }
            },
            {
              path: 'import-history',
              name: 'coupon_import_history',
              component: CouponImportHistory,
              props: true,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':id',
              name: 'coupon_child_create',
              component: CouponBaseFormChild,
              meta: {
                label: 'create'
              },
              props: true
            },
            {
              path: 'edit/:id',
              name: 'coupon_child_edit',
              component: CouponBaseFormChild,
              props: true,
              meta: {
                label: 'edit'
              }
            }
          ]
        },
        {
          path: 'ges-coupon',
          name: 'ges_coupon',
          redirect: '/ges-coupon',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'ges_coupon'
          },
          children: [
            {
              path: '',
              name: 'coupon_ges_list',
              component: CouponGESList,
              props: true,
              meta: {
                label: 'list'
              }
            },
          ]
        },
        {
          path: 'customer-coupon',
          name: 'customer_coupon',
          redirect: '/customer-coupon',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'customer_coupon'
          },
          children: [
            {
              path: '',
              name: 'customer_coupon_list',
              component: CouponCustomerList,
              props: true,
              meta: {
                label: 'list'
              }
            },
            // {
            //   path: ':id',
            //   name: 'customer_coupon_create',
            //   component: CouponBaseFormChild,
            //   meta: {
            //     label: 'create'
            //   },
            //   props: true
            // },
            {
              path: 'edit/:id',
              name: 'customer_coupon_edit',
              component: CouponCustomerBaseForm,
              props: true,
              meta: {
                label: 'edit'
              }
            }
          ]
        },
        {
          path: 'game',
          name: 'game',
          redirect: '/game',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'game'
          },
          children: [
            {
              path: '',
              name: 'game_list',
              component: GameList,
              props: true,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':id',
              name: 'game_create',
              component: GameSettingForm,
              meta: {
                label: 'create'
              },
              props: true
            },
            {
              path: 'edit/:id',
              name: 'game_edit',
              component: GameSettingForm,
              props: true,
              meta: {
                label: 'edit'
              }
            },
            {
              path: '/gaming_rule',
              name: 'game_rule',
              component: GamingRule,
              props: true,
              meta: {
                label: 'edit'
              }
            },
            {
              path: '/grant_token_history',
              name: 'grant_token_history',
              component: HistoryList,
              props: true,
              meta: {
                label: 'edit'
              }
            }
          ]
        },
        {
          path: 'combo',
          name: 'combo',
          redirect: '/combo',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'combo'
          },
          children: [
            {
              path: '',
              name: 'combo_list',
              component: ComboList,
              meta: {
                label: 'list'
              }
            },
            {
              path: 'create-combo',
              name: 'combo_create',
              component: ComboBaseForm,
              props: true,
              meta: {
                label: 'create_combo'
              }
            },
            {
              path: ':uuid/create-combo-group',
              name: 'create_combo_group',
              component: ComboGroupBaseForm,
              props: true,
              meta: {
                label: 'create_combo_group'
              }
            },
            {
              path: ':uuid/update-combo-group',
              name: 'update_combo_group',
              component: ComboGroupForm,
              props: true,
              meta: {
                label: 'update_combo_group'
              }
            },
            {
              path: 'edit/:uuid',
              name: 'combo_edit',
              component: ComboBaseForm,
              props: true,
              meta: {
                label: 'edit_combo'
              }
            },
            {
              path: ':uuid/edit-combo-group',
              name: 'edit_combo_group',
              // component: ComboGroupBaseForm,
              component: ComboGroupForm,
              props: true,
              meta: {
                label: 'edit_combo_group'
              }
            },
            {
              path: 'available/:uuid',
              name: 'combo_available',
              component: ComboAvailableForm,
              props: true,
              meta: {
                label: 'available'
              }
            }
          ]
        },
        {
          path: 'outlets',
          name: 'outlets',
          redirect: '/outlets',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'outlets'
          },
          children: [
            {
              path: '',
              name: 'outlets_list',
              component: OutletsList,
              meta: {
                label: 'list'
              }
            },
            {
              path: 'create',
              name: 'outlets_create',
              component: OutletsForm,
              meta: {
                label: 'create'
              }
            },
            {
              path: 'edit/:uuid',
              name: 'outlets_edit',
              component: OutletsForm,
              meta: {
                label: 'edit'
              }
            },
            {
              path: 'menu-control/:uuid',
              name: 'menu_control',
              props: true,
              component: OutletsMenuControl,
              meta: {
                label: 'edit'
              }
            },
            {
              path: ':uuid/table-control',
              name: 'table-control',
              props: true,
              component: OutletsTableControl,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':uuid/table-control/:action',
              name: 'table-create',
              props: true,
              component: TableForm,
              meta: {
                label: 'create'
              }
            },
            {
              path: 'outlet-out-of-stock/:uuid',
              name: 'outlet_out_of_stock',
              props: true,
              component: OutletOutOfStock,
              meta: {
                label: 'edit'
              }
            },
            {
              path: 'outlet-out-of-stock/menu-out-of-stock/:uuid',
              name: 'new_menu_out_of_stock',
              props: true,
              component: OutletMenuOutOfStock,
              meta: {
                label: 'edit'
              }
            },
            {
              path: 'outlet-out-of-stock/topping-out-of-stock/:uuid',
              name: 'topping_out_of_stock',
              props: true,
              component: OutletToppingOutOfStock,
              meta: {
                label: 'edit'
              }
            },
            {
              path: 'menu-out-of-stock/:uuid',
              name: 'menu_out_of_stock',
              props: true,
              component: MenuOutOfStockList,
              meta: {
                label: 'list'
              }
            },
            {
              path: 'list-of-all-available-deals/:uuid',
              name: 'list_of_all_available_deals',
              props: true,
              component: AvailableDealsList,
              meta: {
                label: 'list'
              }
            },
            {
              path: 'menu-control/menu-exclusion/:uuid',
              name: 'menu_exclusion',
              props: true,
              component: OutletMenuExclusionForm,
              meta: {
                label: 'edit'
              }
            },
            {
              path: 'menu-control/topping-exclusion/:uuid',
              name: 'topping_exclusion',
              props: true,
              component: OutletToppingExclusionForm,
              meta: {
                label: 'edit'
              }
            },
            {
              path: 'tradezone_list/:uuid',
              name: 'tradezone_list',
              component: TradezoneList,
              meta: {
                label: 'list'
              }
            },
            {
              path: 'subtradezones/:id',
              name: 'subtradezones',
              component: SubTradezoneList,
              meta: {
                label: 'list'
              }
            },
            {
              path: 'subtradezones/edit/:id',
              name: 'subtradezones_edit',
              component: FormSubTradezone,
              meta: {
                label: 'edit'
              }
            },
          ]
        },
        {
          path: 'store-group',
          name: 'store_group',
          redirect: '/store-group',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'store_group'
          },
          children: [
            {
              path: '',
              name: 'store_group_list',
              component: StoreGroupList,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':uuid',
              props: true,
              name: 'store_group_create',
              component: StoreGroupForm,
              meta: {
                label: 'create'
              }
            },
            {
              path: 'edit/:uuid',
              name: 'store_group_edit',
              component: StoreGroupForm,
              props: true,
              meta: {
                label: 'edit'
              }
            }
          ]
        },
        {
          path: 'orders',
          name: 'orders',
          redirect: '/orders',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'Orders'
          },
          children: [
            {
              path: '',
              name: 'order_list',
              component: OrderList,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':uuid',
              name: 'order_detail',
              component: OrderDetail,
              meta: {
                label: 'Order detail'
              },
              props: true
            }
          ]
        },
        {
          path: 'order_errors',
          name: 'order_errors',
          redirect: '/order_errors',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'Order Errors'
          },
          children: [
            {
              path: '',
              name: 'order_errors',
              component: ListErrors,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':uuid',
              name: 'order_detail',
              component: OrderDetail,
              meta: {
                label: 'Order detail'
              },
              props: true
            }
          ]
        },
        {
          path: 'category',
          name: 'category',
          redirect: '/category',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'category'
          },
          children: [
            {
              path: '',
              name: 'category_list',
              component: CategoryList,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':uuid',
              name: 'category_create',
              component: CategoryForm,
              meta: {
                label: 'create'
              },
              props: true
            },
            {
              path: 'edit/:uuid',
              name: 'category_edit',
              component: CategoryForm,
              props: true,
              meta: {
                label: 'edit'
              }
            }
          ]
        },
        {
          path: 'client',
          name: 'client',
          redirect: '/client',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'client'
          },
          children: [
            {
              path: '',
              name: 'client_list',
              component: ClientList,
              meta: {
                label: 'list'
              }
            },
            {
              path: 'create-client',
              name: 'client_create',
              component: ClientForm,
              props: true,
              meta: {
                label: 'client_create'
              }
            },
            {
              path: 'edit/:uuid',
              name: 'client_update',
              component: ClientForm,
              props: true,
              meta: {
                label: 'client_update'
              }
            }
          ]
        },
        {
          path: 'customers',
          name: 'customers',
          redirect: 'customers',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'customers'
          },
          children: [
            {
              path: '',
              name: 'customers_list',
              component: CustomersList,
              meta: {
                label: 'customers_list'
              }
            },
            {
              path: 'detail/:cid',
              props: true,
              name: 'customer_detail_list',
              component: CustomerDetail,
              meta: {
                label: 'customer_detail_list'
              }
            }
          ]
        },
        {
          path: 'users',
          name: 'users',
          redirect: 'users',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'users'
          },
          children: [
            {
              path: '',
              name: 'user_list',
              component: UsersList,
              meta: {
                label: 'user_list'
              }
            },
            {
              path: 'create-user',
              name: 'user_create',
              component: UsersForm,
              meta: {
                label: 'user_create'
              }
            },
            {
              path: 'edit/:uuid',
              name: 'user_edit',
              props: true,
              component: UsersForm,
              meta: {
                label: 'user_edit'
              }
            }
          ]
        },
        {
          path: 'roles',
          name: 'roles',
          redirect: 'roles',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'roles'
          },
          children: [
            {
              path: '',
              name: 'role_list',
              component: RoleList,
              meta: {
                label: 'role_list'
              }
            },
            {
              path: 'create-role',
              name: 'role_create',
              component: RoleForm,
              meta: {
                label: 'role_create'
              }
            },
            {
              path: 'edit/:uuid',
              props: true,
              name: 'role_update',
              component: RoleForm,
              meta: {
                label: 'role_edit'
              }
            }
          ]
        },
        {
          path: 'permissions',
          name: 'permissions',
          redirect: 'permissions',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'permissions'
          },
          children: [
            {
              path: '',
              name: 'permission_list',
              component: PermissionList,
              meta: {
                label: 'permission_list'
              }
            },
            {
              path: 'create-permission',
              name: 'permission_create',
              component: PermissionForm,
              meta: {
                label: 'permission_create'
              }
            },
            {
              path: 'edit/:uuid',
              name: 'permission_edit',
              props: true,
              component: PermissionForm,
              meta: {
                label: 'permission_edit'
              }
            }
          ]
        },
        {
          path: 'error-message',
          name: 'error_message',
          redirect: '/error-message',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'error-message'
          },
          children: [
            {
              path: '',
              name: 'error_message_list',
              component: ErrorMessageList,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':uuid',
              name: 'error_message_create',
              component: ErrorMessageBaseForm,
              meta: {
                label: 'create'
              },
              props: true
            },
            {
              path: 'edit/:uuid',
              name: 'error_message_edit',
              component: ErrorMessageBaseForm,
              props: true,
              meta: {
                label: 'edit'
              }
            },
          ]
        },
        {
          path: 'clear-cache',
          name: 'clear_cache',
          component: AwsForm,
          meta: {
            label: 'clear_cache'
          }
        },
        {
          path: 'campaign',
          name: 'campaign',
          redirect: '/campaign',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'campaign'
          },
          children: [
            {
              path: '',
              name: 'campaign_list',
              component: CampaignList,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':uuid',
              name: 'campaign_create',
              component: CampaignForm,
              props: true,
              meta: {
                label: 'campaign_create'
              }
            },
            {
              path: 'edit/:uuid',
              name: 'campaign_edit',
              component: CampaignForm,
              props: true,
              meta: {
                label: 'campaign_edit'
              }
            }
          ]
        },
        {
          path: 'topic',
          name: 'topic',
          redirect: '/topic',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'topic'
          },
          children: [
            {
              path: '',
              name: 'topic_list',
              component: TopicList,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':uuid',
              name: 'topic_create',
              component: TopicForm,
              props: true,
              meta: {
                label: 'topic_create'
              }
            },
            {
              path: 'edit/:uuid',
              name: 'topic_edit',
              component: TopicForm,
              props: true,
              meta: {
                label: 'topic_edit'
              }
            }
          ]
        },
        {
          path: '/',
          name: 'report',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'Roster-Report'
          },
          children: [
            {
              path: 'roster-report',
              name: 'roster-report',
              component: RosterReport,
              meta: {
                label: 'roster-report'
              }
            },
            {
              path: 'hit-rate-report',
              name: 'hit-rate-report',
              component: HitRateReport,
              meta: {
                label: 'hit-rate-report'
              }
            },
            {
              path: 'hourly-sale-report',
              name: 'hourly-sale-report',
              component: HourlySaleReport,
              meta: {
                label: 'hourly-sale-report'
              }
            },
            {
              path: 'order-sales-report',
              name: 'order-sales-report',
              component: NewSalesReport,
              meta: {
                label: 'report_order'
              }
            },
            {
              path: 'coupon-redemption-report',
              name: 'coupon-redemption-report',
              component: CouponRedemptionReport,
              meta: {
                label: 'coupon-redemption-report'
              }
            },
            {
              path: 'hotpods',
              name: 'hotpods',
              component: Hotpods,
              meta: {
                label: 'hotpods'
              }
            },
            {
              path: 'store_health_check',
              name: 'store_health_check',
              component: StoreHealthCheck,
              meta: {
                label: 'store_health_check'
              }
            },
            {
              path: 'contactless-curbside-transactions',
              name: 'contactless_curbside_transactions',
              component: ContactlessCurbsideTransactions,
              meta: {
                label: 'contactless_curbside_transactions'
              }
            }
          ]
        },
        {
          path: 'blacklist',
          name: 'blacklist',
          redirect: '/blacklist',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'blacklist'
          },
          children: [
            {
              path: '',
              name: 'blacklist_list',
              component: BlacklistList,
              props: true,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':uuid',
              name: 'blacklist_create',
              component: BlacklistForm,
              meta: {
                label: 'create'
              },
              props: true
            }
          ]
        },
        {
          path: 'menu-attribute',
          name: 'menu_attribute',
          redirect: '/menu-attribute',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'menu-attribute'
          },
          children: [
            {
              path: '',
              name: 'menu_attribute_list',
              component: MenuAttributeList,
              props: true,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':id',
              name: 'menu_attribute_create',
              component: MenuAttributeForm,
              meta: {
                label: 'create'
              },
              props: true
            },
            {
              path: 'edit/:id',
              name: 'menu_attribute_edit',
              component: MenuAttributeForm,
              props: true,
              meta: {
                label: 'edit'
              }
            }
          ]
        },
        {
          path: 'earning-framework',
          name: 'earning_framework',
          component: EarningFrameworkList,
          meta: {
            label: 'earning-framework'
          },
          children: []
        },
        {
          path: 'email-template',
          name: 'email_template',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'email-template'
          },
          children: [
            {
              path: '/email-template',
              name: 'email_template_list',
              component: EmailTemplateList,
              props: true,
              meta: {
                label: 'list'
              }
            },
            {
              path: 'email-trigger',
              name: 'email_template_trigger_list',
              component: EmailTemplateTriggerList,
              props: true,
              meta: {
                label: 'list'
              }
            },
            {
              path: 'email-trigger/:uuid',
              name: 'email_template_trigger_create',
              component: EmailTemplateTriggerForm,
              props: true,
              meta: {
                label: 'create'
              }
            },
            {
              path: 'email-trigger/:uuid',
              name: 'email_template_trigger_edit',
              component: EmailTemplateTriggerForm,
              props: true,
              meta: {
                label: 'edit'
              }
            },
            {
              path: ':id',
              name: 'email_template_create',
              component: EmailTemplateForm,
              meta: {
                label: 'create'
              },
              props: true
            },
            {
              path: 'edit/:id',
              name: 'email_template_edit',
              component: EmailTemplateForm,
              props: true,
              meta: {
                label: 'edit'
              }
            },
            {
              path: 'diff/:id',
              name: 'email_template_diff',
              component: EmailTemplateDiffForm,
              props: true,
              meta: {
                label: 'diff'
              }
            }
          ]
        },
        {
          path: 'audit-trails',
          name: 'audit_trail',
          redirect: '/audit-trails',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'audit-trails'
          },
          children: [
            {
              path: '',
              name: 'audit-list',
              component: AuditTrail,
              props: true,
              meta: {
                label: 'list'
              }
            },
          ]
        },
        {
          path: 'menu-half-half',
          name: 'menu-half-half',
          redirect: '/menu-half-half',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'menu-half-half'
          },
          children: [
            {
              path: '',
              name: 'menu_half_half_list',
              component: MenuHalfHalfList,
              props: true,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':id',
              name: 'menu_half_half_create',
              component: MenuHalfHalfForm,
              meta: {
                label: 'create'
              },
              props: true
            },
            {
              path: 'edit/:id',
              name: 'menu_half_half_edit',
              component: MenuHalfHalfForm,
              props: true,
              meta: {
                label: 'edit'
              }
            }
          ]
        },
        {
          path: 'reason-status',
          name: 'reason_status',
          redirect: '/reason-status',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'reason-status'
          },
          children: [
            {
              path: '',
              name: 'reason_status_list',
              component: ReasonStatusList,
              meta: {
                label: 'list'
              }
            },
            {
              path: ':uuid',
              name: 'reason_status_create',
              component: ReasonStatusForm,
              meta: {
                label: 'create'
              },
              props: true
            },
            {
              path: 'edit/:uuid',
              name: 'reason_status_edit',
              component: ReasonStatusForm,
              props: true,
              meta: {
                label: 'edit'
              }
            },
          ]
        },
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js